import { render, staticRenderFns } from "./ProceduresToPay.vue?vue&type=template&id=485b2d46"
import script from "./ProceduresToPay.vue?vue&type=script&lang=js"
export * from "./ProceduresToPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports